"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(array) {
  return array.reduce(function (acc, val) {
    acc[val] = val;
    return acc;
  }, {});
};

exports.default = _default;
module.exports = exports.default;